export default "__VITE_ASSET__LUV8rlbY__"